// extracted by mini-css-extract-plugin
export default {"rootWrapper":"AppFrontendAddonProvider__rootWrapper--VItQCtJ"};